






























import LangButton from "@/set/home/LangButton.vue";
import moment from 'moment'
import Vue from 'vue'
import {mapGetters} from "vuex"

export default Vue.extend({
  components: {LangButton},
  data() {
    return {
      sym: ''
    }
  },
  computed: {
    ...mapGetters('set', ['historyReversed']),
  },
  methods: {
    search() {
      this.$router.push({path: `/set/${this.sym.toUpperCase()}`})
    }
  },
  filters: {
    fromNow(date: Date) {
      return moment(date).fromNow()
    }
  }
})
